import { CHEAPER_OPTION_ACTIONS } from './constants';

export const cheaperOptionInitialState = {
  isSending: false,
  isSendingSuccess: false,
  isError: false,
  texts: null,
};

const cheaperOption = (state = cheaperOptionInitialState, action) => {
  switch (action.type) {
    // SEND DATA
    case CHEAPER_OPTION_ACTIONS.SEND_CHEAPER_OPTION:
      return {
        ...state,
        isSending: true,
        isError: false,
        isSendingSuccess: false,
      };
    case CHEAPER_OPTION_ACTIONS.SEND_CHEAPER_OPTION_SUCCESS:
      return {
        ...state,
        isSending: false,
        isError: false,
        isSendingSuccess: true,
      };

    case CHEAPER_OPTION_ACTIONS.SEND_CHEAPER_OPTION_ERROR:
      return {
        ...state,
        isSending: false,
        isSendingSuccess: false,
        isError: true,
      };
    case CHEAPER_OPTION_ACTIONS.FETCH_CHEAPER_OPTION_TEXTS_SUCCESS:
      return {
        ...state,
        texts: action.payload,
      };
    default:
      return state;
  }
};

export default cheaperOption;
